import request from '@/utils/request'


/**
 * 获取试卷结果统计类型 列表
 * @param param
 */
export function getResultTypeList() {
    return request({
        url: '/api/mate/list',
        method: 'post'
    })
}


/**
 * 新增 试卷结果统计类型
 * @param param
 */
export function addResultType(param) {
    return request({
        url: '/api/mate/save',
        method: 'post',
        data: param
    })
}
